import React from "react";
import InquiriesListPresenter from "./InquiriesListPresenter";
import { dialog, Button } from "../../../nq-component";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { exportCSVUseCase } from "../../../usecases/csv/usecases";
import { Progress, InfiniteScroll } from "../../../nq-component";
import withRouter from "../../../withRouter";
import Search from "../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import NavBar from "../../../components/navbar";
import InputFactory from "../../../components/InputFactory";
import Table from "../../../components/Table";
import DropdownMenuButton from "../components/DropdownMenuButton";
import printComponent from "../../../components/printComponent";
import InquiryPrint from "../components/InquiryPrint";
import { saveFileUseCase } from "../../../usecases/file";
import Loader from "../../../components/Loader";
import html2pdf from "html2pdf.js";

async function getBase64ImageFromURL(url) {
  const response = await fetch(url, { mode: "cors" }); // Ensure CORS is enabled
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result); // This is the base64 encoded image
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

class InquiriesListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new InquiriesListPresenter(
      this,
      findObjectUseCase({ include: ["client"] }),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase(),
    );
    this.printRef = React.createRef();
    this.state = {
      ...this.state,
      fetchObject: null,
      isPrintReady: false,
      isGeneratingPDF: false,
    };
  }

  async exportPDF(index) {
    const object = this.state.objects[index];
    const name = object.client?.first_name;
    const surname = object.client?.last_name;
    if (!object) {
      return;
    }

    this.setState({ fetchObject: object }, () => {
      printComponent(
        this.printRef.current,
        `Inquiry_${object?.payment_term || ""}`,
      );
    });

    const element = this.printRef.current;

    if (element) {
      const image = element.querySelectorAll("img");

      const imagePromises = Array.from(image).map(async (img) => {
        console.log("GOGOGOG", img.src);
        try {
          const base64 = await getBase64ImageFromURL(img.src);
          img.src = base64; // Replace the src with base64 encoded image
        } catch (error) {
          console.error("Error loading image:", error);
        }
      });

      console.log("imagePromises", imagePromises);

      try {
        await Promise.all(imagePromises);
        console.log("All images replaced with base64!");

        const opt = {
          margin: 0.5,
          filename: "report.pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: {
            scale: 3,
            scrollX: 0,
            scrollY: 0,
            windowWidth: element.scrollWidth || document.body.scrollWidth,
            windowHeight: element.scrollHeight || document.body.scrollHeight,
            useCORS: true,
          },
          jsPDF: {
            unit: "pt",
            format: "a4",
            orientation: "landscape",
          },
        };

        html2pdf()
          .from(element)
          .set(opt)
          .output("blob")
          .then((pdfBlob) => {
            pdfBlob.name = "report.pdf";

            saveFileUseCase()
              .execute(pdfBlob)
              .then((result) => {
                const linkUrl = `${result.url}?applicationId=ebowr`;
                console.log("result", linkUrl);
                object.link = linkUrl;
                upsertUseCase().execute("inquiries", object);
              })
              .catch((error) => {
                console.log("error", error);
              });
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(pdfBlob);
            downloadLink.download = `Quotation_${name}_${surname}.pdf`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            dialog.close();
          });
      } catch (error) {
        console.error("Error processing images", error);
      }
    } else {
      alert("element ref is not available yet");
    }

    console.log("element", element);
  }

  getStatus(obj) {
    return obj.status || "Draft";
  }

  componentDidUpdate(prevProps, prevState) {
    this.presenter.componentDidUpdate(prevProps, prevState);
  }

  getCollectionName() {
    return "inquiries";
  }

  closeDialog() {
    dialog.close();
  }

  onClickAdd() {
    this.navigateTo(`/inquiries/quotation/form`);
  }

  cancelInquiry(index) {
    this.presenter.cancelInquiry(index);
  }

  closeDeal(index) {
    this.presenter.closeDeal(index);
  }

  onClickView(index) {
    const object = this.state.objects[index];
    this.navigateTo(`/inquiries/quotation/view/${object?.id}`);
  }

  waitForPrintReady() {
    return new Promise((resolve) => {
      const checkReady = () => {
        if (this.state.isPrintReady) return resolve();
        setTimeout(checkReady, 50);
      };
      checkReady();
    });
  }

  async onClickInfo(index) {
    const object = this.state.objects[index];
    if (!object) return;

    this.setState(
      {
        fetchObject: object,
        isPrintReady: false,
        isGeneratingPDF: true,
      },
      () => {
        this.waitForPrintReady()
          .then(() => this.generatePDF(object))
          .catch((err) => {
            console.error("Failed to wait for print readiness", err);
          })
          .finally(() => {
            this.setState({ isLoadingPDF: false });
          });
      },
    );
  }

  async generatePDF(object) {
    const element = this.printRef.current;

    if (!element) {
      alert("PDF content is not ready");
      return;
    }

    const images = element.querySelectorAll("img");
    const imagePromises = Array.from(images).map(async (img) => {
      try {
        const base64 = await getBase64ImageFromURL(img.src);
        img.src = base64;
      } catch (error) {
        console.error("Error loading image:", error);
      }
    });

    try {
      await Promise.all(imagePromises);

      const opt = {
        margin: 0.5,
        filename: "report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 3,
          scrollX: 0,
          scrollY: 0,
          windowWidth: element.scrollWidth || document.body.scrollWidth,
          windowHeight: element.scrollHeight || document.body.scrollHeight,
          useCORS: true,
        },
        jsPDF: {
          unit: "pt",
          format: "a4",
          orientation: "landscape",
        },
      };

      const pdfBlob = await html2pdf().from(element).set(opt).output("blob");
      pdfBlob.name = "report.pdf";

      const result = await saveFileUseCase().execute(pdfBlob);
      const linkUrl = `${result.url}?applicationId=ebowr`;

      object.link = linkUrl;
      await upsertUseCase().execute("inquiries", object);

      try {
        dialog.close();
      } catch (e) {
        console.warn("Dialog close failed (probably not open):", e.message);
      }

      console.log("PDF uploaded and object updated:", linkUrl);

      this.navigateTo(`/inquiries/quotation/info/${object?.id}`);
    } catch (error) {
      console.error("PDF generation failed", error);
    } finally {
      this.setState({ isGeneratingPDF: false });
    }
  }

  onChangeFilter(type, value, field) {
    const where = {};
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id };
        }
        break;
      case "Boolean":
        where[field] = value;
        break;
      default:
        where[field] = { $regex: value, $options: "i" };
    }
    this.searchSubmit(where);
  }

  acceptApplication(index, field) {
    this.presenter.acceptApplication(index, field);
  }

  getActionButtons(status, index) {
    const buttonConfigs = this.presenter.getActionButtonsFor(index);

    return buttonConfigs.map((btn, i) => {
      if (Array.isArray(btn)) {
        return (
          <DropdownMenuButton
            key={`dropdown-${index}`}
            index={index}
            buttons={btn}
          />
        );
      }

      return (
        <button
          key={i}
          className={`btn ${btn.className}`}
          onClick={btn.onClick}
          style={btn.style || {}}
        >
          <i className={`bi bi-${btn.icon}`} /> {btn.label}
        </button>
      );
    });
  }

  onCollapse(index) {
    const data = this.state.objects[index];
    const client = data.client || {};
    const status = this.getStatus(data);
    const actionButtons = this.getActionButtons(status, index);

    return (
      <div className="p-1 text-start">
        <div>
          <strong>First Name:</strong> {client.first_name}
        </div>
        <div>
          <strong>Last Name:</strong> {client.last_name}
        </div>
        <div>
          <strong>Address:</strong> {client.address}
        </div>
        <div>
          <strong>Contact:</strong> {client.contact_number}
        </div>
        <div>
          <strong>Email Address:</strong> {client.email_address}
        </div>
        <div className="mt-2 d-flex align-items-center gap-2">
          {actionButtons}
        </div>
      </div>
    );
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, selected, count, progress } = this.state;

    if (!schema) return <Progress />;
    return (
      <>
        {this.state.isGeneratingPDF && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-50 d-flex justify-content-center align-items-center"
            style={{ zIndex: 1050 }}
          >
            <div className="p-4 bg-white border rounded shadow-lg text-center">
              <Loader>Loading Quotation...</Loader>
            </div>
          </div>
        )}
        <div className="d-none">
          <div ref={this.printRef}>
            <InquiryPrint
              object={this.state.fetchObject}
              onReady={() => this.setState({ isPrintReady: true })}
            />
            {/* change to fetchedObject={fetchObject} */}
          </div>
        </div>
        <NavBar
          action={() => {
            return (
              <div className="dropdown dropstart d-inline-block">
                <i
                  role="button"
                  data-bs-toggle="dropdown"
                  className="bi bi-three-dots-vertical text-black"
                ></i>
                <div className="dropdown-menu fs-xs">
                  <button
                    onClick={this.onClickDeleteSelected.bind(this)}
                    disabled={selected.length < 1}
                    className="dropdown-item py-3"
                  >
                    <i className="bi bi-trash pe-2" />
                    Delete Selected
                  </button>
                </div>
              </div>
            );
          }}
        />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1 className="fw-bold text-capitalize">Inquiries</h1>
              </div>
              <div className="d-flex mt-3">
                {Object.keys(schema.filters || {}).map((field) => {
                  let { type, ...options } = schema.filters[field];
                  return (
                    <InputFactory
                      key={field}
                      className="ms-1"
                      type={type}
                      field={field}
                      where={{}}
                      onChange={this.onChangeFilter.bind(this, type)}
                      {...options}
                    />
                  );
                })}
              </div>
              <Search
                schemas={this.getSchemas()}
                className="mt-3"
                onSubmit={this.searchSubmit.bind(this)}
                fields={schema.fields}
              />
              <Table
                fields={schema.fields}
                objects={objects}
                selectable
                collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "acl",
                    "password",
                    "created",
                    "updated",
                    "logo",
                    "checkbox",
                    "second_logo",
                    "payment_term",
                    "unit_type",
                    "unit",
                    "unit_view",
                    "floor_area",
                    "balcony",
                    "gross_floor_area",
                    "gross_unit_price",
                    "unit_type_discount",
                    "launch_discount",
                    "equity",
                    "reservation_fee",
                    "monthly_amortization",
                    "retention",
                    "closing_fee",
                    "link",
                    "reason",
                  ],
                )}
                selected={selected}
                onSelect={this.onSelect.bind(this)}
                onSelectAll={this.onSelectAll.bind(this)}
                progress={progress}
                onClickItem={this.onClickItem.bind(this)}
                className="mt-3 rounded text-center"
                onCollapse={this.onCollapse.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        <div className="position-fixed bottom-0 end-0 m-4">
          <Button
            className="btn btn-primary shadow-sm bg-primary"
            onClick={this.onClickAdd.bind(this)}
            style={{ width: "50px", height: "50px", borderRadius: "25px" }}
          >
            <i className="bi bi-plus-lg" />
          </Button>
        </div>
      </>
    );
  }
}

export default withRouter(InquiriesListPage);
